import Spinner from '@client/components/Spinner';
import { sendEmailChallenge } from '@client/new/api/auth.api';
import { PinCodeForm } from '@client/new/components/pin-form';
import { useCallback, useState } from 'react';
import { toast } from 'react-hot-toast';
import { browserHistory } from 'react-router';
import { AuthLayout } from './auth.layout';

export const CodeConfirmation = ({
  email,
  verifyCode,
  isVerifying,
  intent,
}: {
  email: string;
  verifyCode: (code: string, errorCallback: () => void) => void;
  isVerifying: boolean;
  intent?: 'login' | 'signup';
}) => {
  const [invalid, setInvalid] = useState(false);

  const resendOTPCode = useCallback(() => {
    sendEmailChallenge(email, intent)
      .then(() => toast.success('Code sent'))
      .catch(() => toast.error('Error sending code'));
  }, [email, intent]);

  if (!email) {
    browserHistory.push('/login');
  }

  return (
    <AuthLayout showGoBack title={'Confirmation code'}>
      <div className="mt-10 flex flex-col item-center">
        <span className="mt-6 text-center">
          {"We've sent a code to "}
          {email}
        </span>
        <div className="mt-6 w-full max-w-sm mx-auto">
          <PinCodeForm
            pinLength={6}
            onInputChange={() => {
              if (invalid) {
                setInvalid(false);
              }
            }}
            onComplete={(code: string) =>
              verifyCode(code, () => setInvalid(true))
            }
            isInvalid={invalid}
          />
        </div>
        {isVerifying && (
          <div className="mt-7">
            <Spinner />
          </div>
        )}
        <p className="mt-10 text-center">
          {"Please check your spam if you don't see it in your inbox."}
        </p>
        <p className="mt-2">
          <span className="">{"Didn't receive one?"}</span>{' '}
          <button className="link" onClick={resendOTPCode}>
            Send again
          </button>
        </p>
      </div>
    </AuthLayout>
  );
};
